import TypedNativeModules from "../internal/TypedNativeModules";
import type { ViewJobHint } from "../types/TareBridge";

export async function updateViewJobHint(jobKey: string, hint: Partial<ViewJobHint>): Promise<void> {
  const tareBridge = TypedNativeModules.RNTareBridge;

  if (!tareBridge?.setCachedViewJobHint || !tareBridge?.getCachedViewJobHint) {
    return;
  }

  const viewJobHint = (await tareBridge.getCachedViewJobHint(jobKey)) || {
    isSaved: null,
    title: null,
    isFromAce: null,
    jobResultTrackingKey: null,
    isDisliked: null,
    matchFactor: null,
  };

  // Override viewJobHint with values from hint
  Object.assign(viewJobHint, hint);

  await tareBridge.setCachedViewJobHint(jobKey, viewJobHint);
}

export async function setCachedViewJobHint(jobKey: string, hint: ViewJobHint): Promise<void> {
  const tareBridge = TypedNativeModules.RNTareBridge;
  if (!tareBridge?.setCachedViewJobHint) {
    return;
  }
  await tareBridge.setCachedViewJobHint(jobKey, hint);
}

export async function getCachedViewJobHint(jobKey: string): Promise<ViewJobHint | null> {
  const tareBridge = TypedNativeModules.RNTareBridge;
  if (!tareBridge?.getCachedViewJobHint) {
    return null;
  }
  return tareBridge.getCachedViewJobHint(jobKey);
}
